// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

/************************************************* Document on ready *********************************************/

$( document ).ready(function() {

    //chosen_candy_bag_children coming from grouped.php
    if(typeof chosen_candy_bag_children !== 'undefined') {
        document.cookie = 'candy_in_bag=' + chosen_candy_bag_children + ';  path=/'
    }

    var match = document.cookie.match(new RegExp('(^| )' + 'open_save_candy_popup' + '=([^;]+)'))
    if(match) {
        $('.save-chosen-candy-bag').show()
        document.cookie = "open_save_candy_popup=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }

    //console.log(document.cookie)

    //search field place
    var search_form = $('.menu-search-form').html()
    $('.menu-item').each( function() {
        if( $(this).find('a').text() == 'Hakukenttä' ) {
            $(this).replaceWith('<div class="menu-search-form">' + search_form + '</div>')
            $('.menu-search-form.original').remove()
        }
    })

    //range input
    const rangeInputs = document.querySelectorAll('input[type="range"]')

    rangeInputs.forEach(input => {
        const min = input.min
        const max = input.max
        const val = input.value

        input.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%'
    })

    //login & register fields
    $('#customer_login').prepend('<div class="action-buttons"><div class="button login-button">Kirjaudu</div><div class="button register-button">Rekisteröidy</div><div class="hr"><span class="slide"></span></div></div>')

    //quantity buttons
    $('.woocommerce .qty').each( function() {
        $(this).before('<span class="remove-from-qty">-</span>')
        $(this).after('<span class="add-to-qty">+</span>')
    })

    //quantity buttons
    $(document).on('click', '.woocommerce .quantity .add-to-qty', function() {
        var qty = $(this).siblings('.qty')
        let val = parseInt( qty.val() ) + 1
        qty.val(val)
        $('.woocommerce table.cart td.actions .button').attr('aria-disabled', false)
        $('.woocommerce table.cart td.actions .button').removeAttr('disabled')
    })

    $(document).on('click', '.woocommerce .quantity .remove-from-qty', function() {
        var qty = $(this).siblings('.qty')
        let val = parseInt( qty.val() ) - 1
        if(val <= 0) {
            val = 0
        }
        qty.val(val)
        $('.woocommerce table.cart td.actions .button').attr('aria-disabled', false)
        $('.woocommerce table.cart td.actions .button').removeAttr('disabled')
    })

    //side-cart
    $(document).on('click', '.open-side-cart', function(e) {
        e.preventDefault()
        $('.xoo-wsc-basket').click()
        $('.xoo-wsc-basket').click()
    })

    $(document).on( 'click', '.xoo-wsch-close', function() {
        $('.xoo-wsc-container').hide()
        $('.xoo-wsc-opac').hide()
    })

    $(document).on( 'click', '.xoo-wsc-basket', function() {
        if( $('.xoo-wsc-container').is(':visible') ){
            $('.xoo-wsc-opac').hide()
            $('.xoo-wsc-container').hide()
        } else {
            $('.xoo-wsc-opac').show()
            $('.xoo-wsc-modal:not(.xoo-wsc-loading) .xoo-wsc-container').show()
        }
    })
})

/********************************************************* Others ********************************************************/

jQuery.fn.outerHTML = function() {
    return jQuery('<div />').append(this.eq(0).clone()).html();
};

$(document).on('click', '.open-popup', function() {
    $(this).parents('.post').nextAll('.popup:first').show()
})

$(document).on('click', '.close-popup', function() {
    $(this).parents('.popup').hide()
})

$(document).on('click', '.close-notification', function() {
    $(this).parent().hide()
})

//range input

const rangeInputs = document.querySelectorAll('input[type="range"]')

function handleInputChange(e) {
  let target = e.target
  if (e.target.type !== 'range') {
    target = document.getElementById('range')
  } 
  const min = target.min
  const max = target.max
  const val = target.value
  
  target.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%'
}

rangeInputs.forEach(input => {
  input.addEventListener('input', handleInputChange)
})

//login & register fields
$(document).on( 'click', '#customer_login .action-buttons .button', function() {
    if($(this).hasClass('register-button')) {
        $('#customer_login .login').hide()
        $('#customer_login .register').show()
        $('#customer_login .action-buttons .hr .slide').css('left', '50%')
    } else {
        $('#customer_login .register').hide()
        $('#customer_login .login').show()
        $('#customer_login .action-buttons .hr .slide').css('left', 0)
    }
})

//when clicked candy bag page submit button
$(document).on( 'click', '.grouped_form .popup button[type=submit]', function() { 
    $(this).parents('.popup').hide()
    $('.maatti-peukku').get(0).play()

    //go to cart page
    $(this).closest('form')[0].submit();
})

//pin-code-form
$(document).ready( function() {
    $('.pin-code-form .number-field.number').click( function() {
        var $pin = $(this).closest('.pin-code-form').find('#order-pin-code');
        var current = $pin.val();
        var next   = current + $(this).text();

        // Option A: enforce a 7-digit max-length
        if ( next.length <= 7 ) {
            $pin.val(next);
        }
    })

    $('.pin-code-form .number-field.remove').click(function(){
        var $pin = $(this).closest('.pin-code-form').find('#order-pin-code');
        $pin.val( $pin.val().slice(0, -1) );   // chop off last character
    });

    $('.pin-code-form .number-field.send').click(function(){
        var pin = $(this).closest('.pin-code-form').find('#order-pin-code').val();
        $(this).closest('.pin-code-form').find('.message').remove()
        if ( pin.length === 7 ) {
            $(this).closest('.pin-code-form').append('<div class="message success">Tilaustasi valmistetaan.</div>')
        } else {
            $(this).closest('.pin-code-form').append('<div class="message error">PIN-koodilla ei löytynyt tilausta.</div>')
        }
    });
})